export default {
    itemOrders : [
        {label: "Keep Order", value: "keep"},
        //{label: "Mesp Expression", value: "mespRanking"},
        {label: "By property", value: "property"},
        {label: "Random Order", value: "random"}
    ],
    orderOptions : [
        {label: "Ascending", value: "asc"},
        {label: "Descending", value: "desc"},
        //{label: "RECO default value", value: ""}
    ],
    comparatorOptions : [
        {label: "Double", value: "DoubleComparator"},
        {label: "String", value: "StringComparator"}
    ],
    propertyOptions : [
        {label: "Dynamic Property", value: "dynamicProperty"},
        {label: "Item Property", value: "itemProperty"}
    ],
}
